class DownloadPriceList {
  constructor(options = {}) {
    this.config = {
      csvs: () => document.querySelectorAll('[data-module="DownloadPricelistCSV"]'),
      xlss: () => document.querySelectorAll('[data-module="DownloadPricelistXLS"]'),
      ...options
    };
  }

  static downloadFile(blob, name) {
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = name; // Name of the downloaded file
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link); // Cleanup
  }

  static resetDownloadInvoiceButton(element) {
    // reset button to original state
    element.classList.remove('is-disabled');
    const icon = element.querySelector('img');
    if (icon) {
      icon.parentElement.classList.remove('c-loader');
      icon.src = icon.dataset.defaultIcon;
    }
  }

  init() {
    const { csvs, xlss } = this.config;

    if (csvs) {
      csvs().forEach(csv => {
        const buttonDownloadCSV = csv;

        buttonDownloadCSV.addEventListener('click', () => {
          const icon = buttonDownloadCSV.querySelector('img');
          if (icon && icon.parentElement) {
            icon.parentElement.classList.add('c-loader');
            icon.src = '/dist/images/icons/loader.svg';
          }
          window.location.href = `/api/pricelist/getPriceListCSV`;
          this.resetDownloadInvoiceButton(csv);
        });
      });
    }

    if (xlss) {
      xlss().forEach(xls => {
        const buttonDownloadXLS = xls;

        buttonDownloadXLS.addEventListener('click', () => {
          const icon = buttonDownloadXLS.querySelector('img');
          if (icon && icon.parentElement) {
            icon.parentElement.classList.add('c-loader');
            icon.src = '/dist/images/icons/loader.svg';
          }
          window.location.href = `/api/pricelist/getPriceListXLS`;
          this.resetDownloadInvoiceButton(xls);
        });
      });
    }
  }
}

export default DownloadPriceList;
